import { h } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'

const StatisticsBar = () => {
  return (
    <section className='full-width Template-brand-stats custom-stats-bar'>
      <div className='stats-bar p-v qa-stats-bar'>
        <div className='sitewidth'>
          <div className='col'>
            <ul className='list list--stats-bar qa-stats-bar' />
            <a className='btn btn--cta' href='/topic/new?type=idea'><Phrase p='create.an.idea' /></a>
          </div>
        </div>
      </div>
    </section>
  )
}
export default StatisticsBar
